"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardTag = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = require("../Box");

var _Text = require("../Text");

var _excluded = ["children"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * `CardTag` is used for the Cards, and is controlled by their `tag` prop.
 * @deprecated
 */


var CardTag = function CardTag(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    borderRadius: 2,
    backgroundColor: "white100"
  }, rest), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "caption",
    px: 1,
    py: 0.3,
    color: "black100"
  }, children));
};

exports.CardTag = CardTag;
CardTag.displayName = "CardTag";